import React from 'react';
import Image from '@atlaskit/image';
import { useIntl } from '@atlassian/jira-intl';
import { FireScreenAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { TaskDescription } from '../components/TaskDescription.tsx';
import { TaskDescriptionParagraph } from '../components/TaskDescriptionParagraph.tsx';
import { TaskCompleteButton } from '../components/TaskCompleteButton.tsx';
import TaskDescriptionRoleRestrictions from '../components/TaskDescriptionRoleRestrictions.tsx';
import createViewLight from './assets/createViewLight.svg';
import createViewDark from './assets/createViewDark.svg';
import { messages } from './createAView.messages.tsx';
import { TASK_CREATE_A_VIEW } from './constants.tsx';
import type { TaskDefinition } from './types.tsx';

const Description = () => {
	const { formatMessage } = useIntl();
	return (
		<TaskDescription>
			<FireScreenAnalytics attributes={{ taskId: TASK_CREATE_A_VIEW }} />
			<Image
				width="100%"
				src={createViewLight}
				srcDark={createViewDark}
				alt={formatMessage(messages.title)}
			/>
			<TaskDescriptionParagraph>{formatMessage(messages.description)}</TaskDescriptionParagraph>
			<TaskDescriptionRoleRestrictions description={formatMessage(messages.roleRestrictionsText)} />
			<TaskCompleteButton taskId={TASK_CREATE_A_VIEW} />
		</TaskDescription>
	);
};

export const createAView = {
	id: TASK_CREATE_A_VIEW,
	title: messages.title,
	description: <Description />,
} satisfies TaskDefinition;
